import React from "react"
import { LocationProvider } from "@reach/router"

import "src/stitches/global"

export const wrapRootElement = ({ element, ...rest }) => {
  return <LocationProvider>{element}</LocationProvider>
}
